<template>
  <div>
    <v-container>
      <v-row class="ma-0">
        <v-col
          class="pa-0 mt-8 mb-4"
          cols="12"
          style="font-weight: 900;font-size: 26px;line-height: 36px;color: #333333;"
        >
          Edit Profile
        </v-col>
        <v-expansion-panels v-model="panel" accordion multiple flat>
          <v-expansion-panel v-for="(item, i) in sections" :key="i">
            <v-expansion-panel-header
              class="profile-expansion-tabs heading-expansion-panel"
            >
              {{ item }}
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="profile-expansion-tabs-content pt-4"
            >
              <v-col
                v-if="item == 'Account Information'"
                class="py-3 pr-md-4 pl-0"
                cols="12"
              >
                <EditAccountInfo />
              </v-col>
              <v-col v-else class="py-3 pr-md-4 pl-0" cols="12">
                <EditPreferences />
              </v-col>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-btn
          class="mt-2"
          text
          color="#506CFF"
          small
          :to="{ name: routerPath.publicUser.children.myMembership.name }"
          exact
        >
          <span class="btn-text">Back To Profile</span>
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import EditPreferences from "../../../components/Profile/EditPreferences.vue";
  import EditAccountInfo from "../../../components/Profile/EditAccountInfo.vue";
  import { ROUTER_URL } from "../../../constants/urls";

  export default {
    name: "EditProfile",
    components: {
      EditPreferences,
      EditAccountInfo,
    },
    data() {
      return {
        routerPath: ROUTER_URL,
        sections: ["Account Information", "Preferences"],
        panel: [0, 1],
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped>
  .heading-expansion-panel {
    font-weight: 900;
    font-size: 18px;
    line-height: 27px;
    color: #333333;
  }
  .profile-expansion-tabs {
    background: #f5f5f5;
    border: 1px solid rgba(51, 51, 51, 0.15);
  }
  .profile-expansion-tabs-content {
    background: #f8f8f8;
    border: 1px solid rgba(51, 51, 51, 0.15);
  }
  .btn-text {
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
    text-decoration-line: underline;
    color: rgba(51, 51, 51, 0.7);
  }
</style>
